import { Dispatch, Action } from 'redux';

// Action types
export const SET_SIDENAV_STATE = 'SET_SIDENAV_STATE';
export const SET_SIDENAV_SECTION_STATE = 'SET_SIDENAV_SECTION_STATE';


interface UpdateSideNAV extends Action<typeof SET_SIDENAV_STATE> {
    payload: boolean
}

interface UpdateSideNAVSection extends Action<typeof SET_SIDENAV_SECTION_STATE> {
    payload: string
}

export type ActionTypes =  UpdateSideNAV | UpdateSideNAVSection

// Action creators

const updateSideNAVState = (value: boolean): UpdateSideNAV => ({ type: SET_SIDENAV_STATE , payload: value });
const updateSideNAVSectionState = (value: string): UpdateSideNAVSection => ({ type: SET_SIDENAV_SECTION_STATE , payload: value });


// Async action creators
const updateSideNav =(value: boolean)=>{
    return async (dispatch: Dispatch) => {
        dispatch(updateSideNAVState(value))
    }
}

const updateSideNavSection =(value: string)=>{
    return async (dispatch: Dispatch) => {
        dispatch(updateSideNAVSectionState(value))
    }
}


const actions = {
 updateSideNav,
 updateSideNavSection
}

export default actions
